import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { accountService, AccountForms } from '@lib/state';
import { ResponsiveContainer, useFormEvents, VerifiedEmailConfirmation } from '@lib/common';

export const VerifyEmailPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email') || '';
  const token = queryParams.get('token') || '';
  const history = useHistory();
  if (!email || !token) {
    history.push('/');
  }

  const [result] = useFormEvents(AccountForms.VerifyEmail);
  useEffect(() => {
    accountService.verifyEmail(email, token);
  }, [email, token]);

  return (
    <ResponsiveContainer>
      <VerifiedEmailConfirmation result={result} />
    </ResponsiveContainer>
  );
};
